export default __webpack_public_path__ + "static/media/pic7.5fb1f319.png";